const MapIcon = (props) => {
    return (
        <i className="icofont icofont-map-pins f20" style={{ cursor: "pointer" }}></i>
    );
}
export default MapIcon